import {addParamToUrl, getUrlParameter, removeParamFromUrl} from "./urlHelpers";
import {getCurrencyFromLocale, getLocale} from "./localeUtils";
import {initCarousels} from "./carousel";

export function displayFilteredPlaces(resetPagination = true) {
    const filterResults = $("#filter-results");
    const filterLoading = $("#filter-loading");
    const filterTotalWrap = $("#filter-total-wrap");
    const filterTotal = $("#filter-total");
    const locale = getLocale();

    const params = filterParams(resetPagination);

    $.ajax({
        url: "/parts/" + locale + "/filtered-places",
        method: "GET",
        data: params,
        beforeSend: function () {
            filterTotalWrap.removeClass("active");
            filterLoading.addClass("active");
        },
        success: function (result) {
            filterResults.html(result);
            filterLoading.removeClass("active");

            let total = $("#filter-total-value").data("value");

            filterTotal.html(total);
            filterTotalWrap.addClass("active");

            initCarousels();
        }
    })
}

export function displaySideFilter() {
    const sideFilter = $("#side-filter");
    const locale = getLocale();

    $.ajax({
        url: "/parts/" + locale + "/side-filter",
        method: "GET",
        data: filterParams(),
        beforeSend: function () {
            sideFilter.addClass("loading");
        },
        success: function (result) {
            sideFilter.html(result);
            displaySlider("pricePerNight", getCurrencyFromLocale(locale));
            displaySlider("bedrooms");
            //displayPricePerNightSlider();
            //displayBedroomsSlider();
            updatePlaceFeatures();
            sideFilter.removeClass("loading");
        }
    })
}

function updatePlaceFeatures() {
    let checked = localStorage.getItem("filterFeatures");

    if (checked) {
        let checked_arr = checked.split(",");

        for (let i = 0; i < checked_arr.length; i++) {
            let item = $("input[data-feature=" + checked_arr[i] + "]");
            item.attr("checked", true);
        }
    }
}

function displayPricePerNightSlider() {
    const pricePerNightMax = parseInt($("#pricePerNightMax").data("value"));

    if (!pricePerNightMax) {
        //empty, do not render price slider
        $(".pricePerNight-group").hide();

        return null;
    }

    const pricePerNightMin = parseInt($("#pricePerNightMin").data("value"));

    const filterPriceFrom = localStorage.getItem("filter-pricePerNight-from");
    const filterPriceTo = localStorage.getItem("filter-pricePerNight-to");

    let priceFrom, priceTo;

    if (filterPriceFrom && filterPriceTo) {
        priceFrom = parseInt(filterPriceFrom);
        priceTo = parseInt(filterPriceTo);
    } else {
        priceFrom = pricePerNightMin;
        priceTo = pricePerNightMax;
        localStorage.setItem("filter-pricePerNight-from", priceFrom);
        localStorage.setItem("filter-pricePerNight-to", priceTo);
    }

    const perNightSlider = $("#pricePerNightSlider");

    let currency = getCurrencyFromLocale(getLocale());

    perNightSlider.slider({
        range: true,
        min: pricePerNightMin,
        max: pricePerNightMax,
        values: [priceFrom, priceTo],
        slide: function (event, ui) {
            $("#pricePerNight").val(ui.values[0] + " " + currency + " – " + ui.values[1] + " " + currency);
            $("#filter-total-wrap").removeClass("active");
            $("#filter-loading").addClass("active");
        },
        stop: function (event, ui) {
            localStorage.setItem("filter-pricePerNight-from", ui.values[0]);
            localStorage.setItem("filter-pricePerNight-to", ui.values[1]);
            removeParamFromUrl("p");
            displayFilteredPlaces();
        }
    });

    $("#pricePerNight").val(perNightSlider.slider("values", 0) +
        " " + currency + " – " + perNightSlider.slider("values", 1) + " " + currency);
}

function displaySlider(fieldNameBase, currency= "") {
    const preferenceKeyFrom = "filter-" + fieldNameBase + "-from";
    const preferenceKeyTo = "filter-" + fieldNameBase + "-to";

    const maxValue = parseInt($("#" + fieldNameBase +"Max").data("value"));

    if (!maxValue) {
        //empty, do not render slider
        $("." + fieldNameBase + "-group").hide();

        return null;
    }

    const minValue = parseInt($("#" + fieldNameBase + "Min").data("value"));

    const preferenceFrom = localStorage.getItem(preferenceKeyFrom);
    const preferenceTo = localStorage.getItem(preferenceKeyTo);

    let valueFrom, valueTo;

    if (preferenceFrom && preferenceTo) {
        valueFrom = parseInt(preferenceFrom);
        valueTo = parseInt(preferenceTo);
    } else {
        valueFrom = minValue;
        valueTo = maxValue;
        localStorage.setItem(preferenceKeyFrom, valueFrom);
        localStorage.setItem(preferenceKeyTo, valueTo);
    }

    const slider = $("#" + fieldNameBase + "Slider");

    slider.slider({
        range: true,
        min: minValue,
        max: maxValue,
        values: [valueFrom, valueTo],
        slide: function (event, ui) {
            $("#" + fieldNameBase).val(ui.values[0] + " " + currency + " – " + ui.values[1] + " " + currency);
            $("#filter-total-wrap").removeClass("active");
            $("#filter-loading").addClass("active");
        },
        stop: function (event, ui) {
            localStorage.setItem(preferenceKeyFrom, ui.values[0]);
            localStorage.setItem(preferenceKeyTo, ui.values[1]);

            if(fieldNameBase === "pricePerNight") {
                addParamToUrl("priceFrom", ui.values[0]);
                addParamToUrl("priceTo", ui.values[1]);
            } else if(fieldNameBase === "bedrooms") {
                addParamToUrl("bedroomsFrom", ui.values[0]);
                addParamToUrl("bedroomsTo", ui.values[1]);
            }

            removeParamFromUrl("p");
            displayFilteredPlaces();
        }
    });

    $("#" + fieldNameBase).val(slider.slider("values", 0) +
        " " + currency + " – " + slider.slider("values", 1) + " " + currency);
}

function filterParams(resetPagination = true) {
    let params = {
        capacityMode: localStorage.getItem("filterCapacityMode"),
        capacity: localStorage.getItem("filterCapacity"),
        pricePerNightFrom: localStorage.getItem("filter-pricePerNight-from"),
        pricePerNightTo: localStorage.getItem("filter-pricePerNight-to"),
        bedroomsFrom: localStorage.getItem("filter-bedrooms-from"),
        bedroomsTo: localStorage.getItem("filter-bedrooms-to"),
        features: localStorage.getItem("filterFeatures"),
        dateFrom: localStorage.getItem("filterDateFrom"),
        dateTo: localStorage.getItem("filterDateTo"),
        orderBy: localStorage.getItem("filterOrderBy")
    };

    if (localStorage.hasOwnProperty("filterRegionId")) {
        params["region"] = localStorage.getItem("filterRegionId");
    }
    else if(localStorage.hasOwnProperty("filterCountryId")) {
        params["country"] = localStorage.getItem("filterCountryId");
    }
    else if (localStorage.hasOwnProperty("filterCity")) {
        params["city"] = localStorage.getItem("filterCity");
    }

    if(resetPagination === false) {
        const page = parseInt(getUrlParameter("p"));
        if (page) {
            //console.log("setting page " + page);
            params["page"] = page;
        }
    }

    return params;
}

export function updateFilter(resetPagination = true) {
    displayFilteredPlaces(resetPagination);
    displaySideFilter();
}